import type { ApiContact, ApiUser } from '../../api/types';

import { isUserBot } from './users';

export function getContactUsername(user: ApiUser): string | undefined {
  const fromUsernames = user.usernames?.find((u) => u.username)?.username;
  return fromUsernames || user.username;
}

export function canShareContact(user: ApiUser): boolean {
  if (user.isSelf || isUserBot(user)) {
    return false;
  }

  return Boolean(getContactUsername(user));
}

export function buildContactVcard(params: {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  username?: string;
}): string {
  const { firstName, lastName, phoneNumber, username } = params;
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${fullName}`,
    `N:${lastName};${firstName};;;`,
  ];

  if (phoneNumber) {
    lines.push(`TEL;TYPE=CELL:${phoneNumber}`);
  }

  if (username) {
    lines.push('X-TG-VCARD:1.0');
    lines.push(`X-TG-USERNAME:${username}`);
  }

  lines.push('END:VCARD');

  return lines.join('\n');
}

export function buildApiContactFromUser(user: ApiUser): ApiContact | undefined {
  const username = getContactUsername(user);
  if (!username) {
    return undefined;
  }

  const firstName = user.firstName || username;
  const lastName = user.lastName || '';
  const phoneNumber = `@${username}`;

  return {
    firstName,
    lastName,
    phoneNumber,
    userId: user.id,
    vcard: buildContactVcard({
      firstName,
      lastName,
      phoneNumber,
      username,
    }),
  };
}
